import { useCallback } from 'react';
import { FilterOperator, type FilterValue } from './types';

interface UseFilterProps {
	value: FilterValue | null;
	onChange: (value: Partial<FilterValue>) => void;
	close: () => void;
	isNestedList?: boolean;
	openNested?: () => void;
}

export function useFilter({
	value,
	onChange,
	close,
	isNestedList,
	openNested,
}: UseFilterProps) {
	const handleOnChange = useCallback(
		(newValue: Partial<FilterValue>, shouldClose: boolean) => {
			if (!value) {
				return;
			}

			onChange(newValue);

			if (shouldClose) {
				close();
			}

			if (
				isNestedList &&
				value.operator === FilterOperator.Contains &&
				!!newValue.value &&
				openNested &&
				shouldClose
			) {
				openNested();
			}
		},
		[close, onChange, value, isNestedList, openNested]
	);

	return {
		handleOnChange,
	};
}
